<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <Signature />
    </PageRowWrapper>

  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import Signature from '@/components/settings/atendimentos/signature/Signature'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'Signatures',
  components: {
    PageTitle,
    PageRowWrapper,
    Signature,
    LoadingPage
  }
}
</script>
